import Button from 'Components/shared/button';
import { InputWithAdornment } from 'Components/shared/inputs';
import Text from 'Components/shared/text';
import React, { useEffect, useRef } from 'react';
import styles from '../wallet.module.css';

const Formatter = Intl.NumberFormat("en-US");

const WithdrawAmount = ({values, errors, handleUpdate, setValues, touch,
     onNext, onPrevious}) => {
     
        const moneyHandler = (action) => (e) => {
            e.preventDefault();
            const amount = action === "increment" ? "₦" + Formatter.format((+values.amount.replace(/₦|\,/g, '') + 10)) : "₦" + Formatter.format(+values.amount.replace(/[₦\,]+/g, '') - 10) ;
     
            setValues({...values, amount});
        }
        const InputRef = useRef();
        useEffect(() => {
            InputRef.current.focus();
        },[]);
    return (
        <div className={styles.Deposit}>
            <Text variant="lg" style={{fontWeight:700}}>
                Amount to withdraw 
            </Text>
            <div className={`row-start w-full`} style={{gap:"10px",margin:"41px 0"}}>
                <Button variant="outlined" 
                style={{flexGrow:0,minWidth:0, fontSize:"50px", minWidth:"78px", 
                 height:"78px", padding:"31px",textAlign:"top", paddingTop:"21px",
                 borderRadius:"5px", fontWeight:"300",
                 borderColor:"#CBD5E1", color:"var(--primary-text)"}}
                 onClick={moneyHandler("decrement")}
                >-</Button>
                <InputWithAdornment
                ref={InputRef}
                    name="amount"
                    id="amount"
                    className={styles.Amount}
                    value={values?.amount || "₦" }
                    {
                        ...handleUpdate()
                    }
                    error={errors?.amount}
                    parentStyle={{maxWidth:"calc(100% - 176px)"}}
                    onInput={(e) => {
                        e.target.value = "₦" + Formatter.format(e.target.value.replace(/[₦\,]+/g, ''));
                    }}
                    style={{height:"78px", fontSize:"24px",textAlign:"center", 
                    fontWeight:"700", minWidth:0}}
                />
                <Button variant="outlined" 
                style={{flexGrow:0,minWidth:0, fontSize:"50px", minWidth:"78px", 
                height:"78px", padding:"31px",textAlign:"top",
                borderRadius:"5px", fontWeight:"300",
                borderColor:"#CBD5E1", color:"var(--primary-text)"}}
                onClick={moneyHandler("increment")}
                >+</Button>
            </div>
            <Button onClick={onNext}  fullWidth>Continue</Button>
        </div>
    )

}

export default WithdrawAmount;